"use strict";

var _require = require('../utils/endpoints'),
    catalogSSOUrl = _require.catalogSSOUrl,
    cashierUrl = _require.cashierUrl;

var _require2 = require('../utils/error'),
    throwServiceError = _require2.throwServiceError;

var SERVICE_NAME = 'catalog';

module.exports = function (context) {
  var fetch = context.fetch;
  var LANDING_PAGES = {
    MERCHANDISE: 'merchandiseLanding',
    EXPERIENCES: 'experiencesMarketplace'
  };

  var getMenuItems = function getMenuItems() {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var person, _context$services, companyService, rosterService, company, supplier, country, supplierType, query, res, data, menuItems;

      person = $args.length > 0 && $args[0] !== undefined ? $args[0] : {};
      _context$services = context.services, companyService = _context$services.companyService, rosterService = _context$services.rosterService;

      var $Try_1_Post = function () {
        try {
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };

      var $Try_1_Catch = function (error) {
        try {
          throwServiceError(SERVICE_NAME, error, 'getMenuItems');
          return $Try_1_Post();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };

      try {
        return Promise.resolve(companyService.getCompany()).then(function ($await_5) {
          try {
            company = $await_5;

            if (!company) {
              return $return([]);
            }

            if (!person.id) {
              return $return([]);
            }

            if (!person.country) {
              return Promise.resolve(rosterService.getPersonDetailed(person.id)).then(function ($await_6) {
                try {
                  person = $await_6;

                  if (!person) {
                    return $return([]);
                  }

                  return $If_3.call(this);
                } catch ($boundEx) {
                  return $Try_1_Catch($boundEx);
                }
              }.bind(this), $Try_1_Catch);
            }

            function $If_3() {
              supplier = company.countryList.find(function (c) {
                return c.iso3Code === person.country;
              });

              if (!supplier) {
                return $return([]);
              }

              country = supplier.iso3Code;
              supplierType = 'INTERNAL';

              if (!supplier.supplierName.trim().toLowerCase().startsWith('bi internal')) {
                supplierType = 'EXTERNAL';
              }

              query = ["supplierType=".concat(encodeURIComponent(supplierType)), "countryCode=".concat(country)].join('&');
              return Promise.resolve(fetch("".concat(catalogSSOUrl, "/menu?").concat(query))).then(function ($await_7) {
                try {
                  res = $await_7;
                  return Promise.resolve(res.json()).then(function ($await_8) {
                    try {
                      data = $await_8;

                      if (!res.ok) {
                        return $return([]);
                      }

                      menuItems = data.menuItems;

                      if (!menuItems) {
                        return $return([]);
                      }

                      return $return(menuItems.map(function (item) {
                        item.image = null;

                        if (item.pageType === 'merchandise') {
                          item.image = 'https://api.biw.cloud/v1/images/98a8632d-cc24-4914-b0ac-82a0f4b33355';
                          item.image300x300 = 'https://api.biw.cloud/v1/images/dc8d448d-a6bc-4703-9670-9587ef69f61b';
                          item.image176x176 = 'https://api.biw.cloud/v1/images/26567a5e-6f02-488e-802a-4c0d37a338c4';
                          item.image88x88 = 'https://api.biw.cloud/v1/images/a949bc53-187c-4b61-916f-6df193ac56c3';
                        } else if (item.pageType === 'experiences') {
                          item.image = 'https://api.biw.cloud/v1/images/fae7cc9a-92d2-4abf-958c-d392ebff0580';
                          item.image300x300 = 'https://api.biw.cloud/v1/images/78f1f7c1-d1a4-47a3-9800-adae8b2b2095';
                          item.image176x176 = 'https://api.biw.cloud/v1/images/8840af76-3f20-4fe3-95e9-bf430f737aa6';
                          item.image88x88 = 'https://api.biw.cloud/v1/images/cd271b42-4d5a-4165-a5a4-ec0c582ad254';
                        }

                        return item;
                      }).sort(function (a, b) {
                        return a.displayOrder - b.displayOrder;
                      }));
                    } catch ($boundEx) {
                      return $Try_1_Catch($boundEx);
                    }
                  }, $Try_1_Catch);
                } catch ($boundEx) {
                  return $Try_1_Catch($boundEx);
                }
              }, $Try_1_Catch);
            }

            return $If_3.call(this);
          } catch ($boundEx) {
            return $Try_1_Catch($boundEx);
          }
        }.bind(this), $Try_1_Catch);
      } catch (error) {
        $Try_1_Catch(error)
      }
    });
  };

  var getMarketplaceUrl = function getMarketplaceUrl() {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var person, landing, rosterService, response, _await$response$json, shopUrl, reason;

      person = $args.length > 0 && $args[0] !== undefined ? $args[0] : {};
      landing = $args.length > 1 && $args[1] !== undefined ? $args[1] : LANDING_PAGES.MERCHANDISE;
      rosterService = context.services.rosterService;

      if (!person.id) {
        return $error(new Error('no person id'));
      }

      if (!person.country) {
        return Promise.resolve(rosterService.getPersonDetailed(person.id)).then(function ($await_9) {
          try {
            person = $await_9;

            if (!person) {
              return $error(new Error('person not found'));
            }

            return $If_4.call(this);
          } catch ($boundEx) {
            return $error($boundEx);
          }
        }.bind(this), $error);
      }

      function $If_4() {
        var $Try_2_Post = function () {
          try {
            return $return();
          } catch ($boundEx) {
            return $error($boundEx);
          }
        };

        var $Try_2_Catch = function (error) {
          try {
            throwServiceError(SERVICE_NAME, error, 'getMarketplaceUrl');
            return $Try_2_Post();
          } catch ($boundEx) {
            return $error($boundEx);
          }
        };

        try {
          return Promise.resolve(fetch("".concat(cashierUrl, "/account/id/").concat(person.id, "/catalog-sso"), {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              landingPage: landing,
              country: person.country
            })
          })).then(function ($await_10) {
            try {
              response = $await_10;
              return Promise.resolve(response.json()).then(function ($await_11) {
                try {
                  _await$response$json = $await_11, shopUrl = _await$response$json.shopUrl, reason = _await$response$json.reason;

                  if (reason) {
                    throwServiceError(SERVICE_NAME, reason, 'getMarketplaceUrl');
                  }

                  return $return(shopUrl);
                } catch ($boundEx) {
                  return $Try_2_Catch($boundEx);
                }
              }, $Try_2_Catch);
            } catch ($boundEx) {
              return $Try_2_Catch($boundEx);
            }
          }, $Try_2_Catch);
        } catch (error) {
          $Try_2_Catch(error)
        }
      }

      return $If_4.call(this);
    });
  };

  return {
    getMenuItems: getMenuItems,
    getMarketplaceUrl: getMarketplaceUrl
  };
};
//# sourceMappingURL=catalog.js.map